<template>
  <div class="textarea-input clearfix form-group" v-bind:class="{ 'has-feedback' : field.dirty }">
    <label v-bind:for="field.name" class="col-sm-4 control-label">{{ field.label }}</label>
    <div class="col-sm-8">
      <textarea v-bind:id="field.name" class="form-control" type="text" v-model="field.value" v-bind:name="field.name" v-bind:style="{minHeight: field.height || '350px'}"></textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextareaInput',
  props: {
    field: {
      type: Object,
      default () {
        return {
          value: '',
          valid: false,
          dirty: false
        }
      }
    }
  },
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// TextareaInput.vue?6a91d3bc